import React, { Component } from 'react';
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getStoreVersions } from '../../store/editStoreActions';
import { Link } from 'react-router-dom';
import './RestoreStore.css';

class RestoreStore extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.props.getStoreVersions();
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        toggle={this.props.onClose}
        className={'restore-modal'}
      >
        <ModalHeader>Restore from a backup</ModalHeader>
        <ModalBody>
          <Alert color="warning" className="mb-0">
            <strong>Warning</strong>: restoring a previous version of the store
            will discard any current unsaved changes.
          </Alert>

          {this.props.versions && (
            <React.Fragment>
              <Table>
                <thead>
                  <tr>
                    <th>Saved on</th>
                    <th className="pl-0">Saved by</th>
                  </tr>
                </thead>
              </Table>
              <div className="table-wrapper table-responsive">
                <Table>
                  <tbody>
                    {this.props.versions.map(v => {
                      const date = new Date(v.createdAt * 1000);
                      return (
                        <tr key={v.Id}>
                          <td>
                            <Link
                              to={`/edit/${this.props.activeStoreId}/${v.id}`}
                            >
                              {date.toLocaleString()}
                            </Link>
                          </td>
                          <td>{v.createdBy}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </React.Fragment>
          )}

          {!this.props.versions && <div>Loading...</div>}
        </ModalBody>
        <ModalFooter>
          <div className="button-panel">
            <Button onClick={this.props.onClose} color="link">
              Cancel
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getStoreVersions
    },
    dispatch
  );

const mapStateToProps = ({ activeStore }) => {
  return {
    versions: activeStore[activeStore.activeStore].versions,
    activeStoreId: activeStore.activeStore
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestoreStore);



// WEBPACK FOOTER //
// ./src/components/RestoreStore/RestoreStore.js